// extracted by mini-css-extract-plugin
export default {"card":"styles_card__r5fET","image":"styles_image__LFIYl","bottom":"styles_bottom__FnIZu","rotate":"styles_rotate__IAiZL"};